export default {
  pt:{
    nomeunidade: "Conselho Geral",
    menu:{
      apresentacao: "Conselho Geral",
      composicao: "Composição",
      comissoes: "Comissões",
      reunioes: "Reuniões",
      eleicoes: "Processos Eleitorais",
      regulamentos: "Regulamentos",
      noticiaseventos: "Notícias e Eventos"
    },
    apresentacao:{
      horario: "Horário de Expediente",
      horariosecontactos: "Horário e Contactos",
      email: "Email",
      telefone: "Telefone",
      morada: "Morada",
      fax: "Fax",
      conhercerequipa: "Conhecer Equipa",
      responsavel: "Responsável",
      descricao:`<b>"O Conselho Geral é o órgão de governo da Universidade a que 
      cabe definir o desenvolvimento estratégico e a supervisão da instituição."</b><br><br>
      <span class="torigth">In, Regulamento do Conselho Geral, artigo 1º</span>`
    },
    composicao:{
      presidente: "Presidente",
      profs: "Representante dos Professores e Investigadores",
      estudantes: "Representante dos Estudantes",
      naodocentes: "Representante dos trabalhadores Não Docentes/Não Investigadores",
      externa: "Personalidade Externa",
    },
    reuniao:{
      reunioesde: "Reuniões de",
      reuniaode: "Reunião de",
      pesquisa: "Pesquisar Documentos",
      refproc: "REF. PROCEDIMENTO",
      designacao: "DESIGNAÇÃO",
      tipoproc: "TIPO PROCEDIMENTO",
      datalimite: "DATA LIMITE",
      estado: "ESTADO",
      vertodos: "Ver todos os anúncios",
      UMA_LANG_DOCSBOLSA_ESTADO_ACTUAL: "Estado Atual",
      UMA_LANG_CONSELHOGERAL_REUNIAO_NUMEROTEXTO: "Reunião nº",
      UMA_LANG_CONSELHOGERAL_REUNIAO_DATAEHORA: "Data e hora da Reunião",
      UMA_LANG_CONSELHOGERAL_REUNIAO_ATAS: "Atas",
      UMA_LANG_CONSELHOGERAL_REUNIAO_DELIBERACOES: "Deliberações",
      UMA_LANG_CONSELHOGERAL_REUNIAO_DOCUMENTACAO: "Documentação",
      vertodos: "Ver todas as Reuniões",
      maisreunioes: "Para mais informações sobre as reuniões do Conselho Geral de data anterior a 2020 aceda <a href='https://testuma.sharepoint.com/sites/orgaos/conselhogeral/'>aqui</a>"
    },
    eleicoes:{
      ano: "Ano",
      tipo: "Tipo",
      nome: "Nome",
      vertodos: "Ver todos os processos eleitorais"
    },
    noticias:{
      data: "Data",
      titulo: "Titulo",
      vertodos: "Ver todas as Notícias e Eventos"
    },
    regulamentos:{
      pesquisa: "Pesquisar Documentos"
    },
    forms:{
      pesquisaforms: "Pesquisar Formulários"
    },
    list:{
      ano: "Ano",
      designacao: "Designação",
      documentos: "Documentos"
    },
    breadcrumb:{
      homepage: "Homepage",
      sobre: "Sobre",
      admin: "Orgãos de Governo",
      sigla: "Conselho Geral",
    },
    apesquisar: "A pesquisar",
    semdocumentos: "Sem documentos para apresentar",
  },
  en: {
    nomeunidade: "General Council",
    menu:{
      apresentacao: "General Council",
      composicao: "Composition",
      comissoes: "Committees",
      reunioes: "Meetings",
      eleicoes: "Electoral Processes",
      regulamentos: "Regulations",
      noticiaseventos: "News and Events"
    },
    apresentacao:{
      horario: "Office Hours",
      horariosecontactos: "SCHEDULE AND CONTACTS",
      email: "Email",
      telefone: "Telephone",
      morada: "Address",
      conhercerequipa: "Meet the team",
      descricao: `The General Council is formed by twenty-one members, eleven being 
      professors and researchers, three are students, one is a member of staff and
      six are external to the University and of recognized merit, with relevant 
      knowledge and expertise for the institution.`
    },
    composicao:{
      presidente: "President",
      profs: "Teacher Representative",
      estudantes: "Student Representative",
      naodocentes: "Employee Representative",
      externa: "External Personality",
    },
    reuniao:{
      reunioesde: "Meetings for",
      reuniaode: "Meeting for",
      pesquisa: "Pesquisar Documentos",
      refproc: "REF. PROCEDIMENTO",
      designacao: "DESIGNAÇÃO",
      tipoproc: "TIPO PROCEDIMENTO",
      datalimite: "DATA LIMITE",
      estado: "ESTADO",
      vertodos: "Ver todos os anúncios",
      UMA_LANG_DOCSBOLSA_ESTADO_ACTUAL: "Estado Atual",
      UMA_LANG_CONSELHOGERAL_REUNIAO_NUMEROTEXTO: "Meeting Number",
      UMA_LANG_CONSELHOGERAL_REUNIAO_DATAEHORA: "Meeting Date and Hour",
      UMA_LANG_CONSELHOGERAL_REUNIAO_ATAS: "Minutes",
      UMA_LANG_CONSELHOGERAL_REUNIAO_DELIBERACOES: "Deliberations",
      UMA_LANG_CONSELHOGERAL_REUNIAO_DOCUMENTACAO: "Documentation",
      vertodos: "See all Meetings",
      maisreunioes: "For more information on General Council meetings from before 2020 please click <a href='https://testuma.sharepoint.com/sites/orgaos/conselhogeral/'>here</a>"
    },
    eleicoes:{
      ano: "Year",
      tipo: "Type",
      nome: "Name",
      vertodos: "See all Electoral Processes"
    },
    noticias:{
      data: "Date",
      titulo: "Title",
      vertodos: "See All News"
    },
    regulamentos:{
      pesquisa: "Search for Documents"
    },
    list:{
      ano: "Year",
      designacao: "Designation",
      documentos: "Documents"
    },
    breadcrumb:{
      homepage: "Homepage",
      sobre: "About",
      admin: "Governing Bodies",
      sigla: "General Council",
    },
    apesquisar: "Searching",
    semdocumentos: "No documents to be shown",
  }
}